module.exports = __webpack_public_path__ + "public/Icons/manage_notifications.svg?d55641f8";